import MarketData from './src/market-data';
import { VERSION } from './src/var';

const marketsMarketData = new MarketData();

marketsMarketData.version = VERSION;

export default marketsMarketData;
